/**
 * tradingCards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const tradingCardsPack: ToilePack = {
    slug: 'trading-cards',
    category: 'tradingcards',
    name: 'Trading cards',
    tagline: tagline('cards', 'card types', 'frames'),
    chips: chips('card types', 'frames'),
    ratio: PORTRAIT,
    readings: [
        {key: 'dragon', label: 'Ember Wyrm', subject: 'a creature card: a red dragon coiled on a hoard of gold, wings spread'},
        {key: 'artifact', label: 'The Orrery', subject: 'an artifact card: a bronze orrery on a plinth in a vaulted hall'},
        {key: 'hero', label: 'Ironhold', subject: 'a hero card: a knight-captain raising a banner on a windswept ridge'},
    ],
    styles: [
        {key: 'painted', label: 'Painted fantasy', style: 'an ornate gold-and-leather frame with corner filigree', palette: 'oil-style art, warm parchment panel', framing: 'art window above, rules panel below'},
        {key: 'holo', label: 'Holographic', style: 'a brushed-metal frame with glowing cyan circuit traces', palette: 'iridescent foil sheen, neon-lit art', framing: 'art window above, rules panel below'},
        {key: 'comic', label: 'Retro comic', style: 'a thick black keyline over a halftone dot ground', palette: 'flat four-color, off-register newsprint', framing: 'art window above, rules panel below'},
    ],
    directions: ['a frost giant instead', 'in cold blue and silver', 'a rarer, more ornate frame'],
}
